/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RunProgramData } from './RunProgramData';
const RunProgramExtraParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('run_program')],
    ['data', RunProgramData],
]);
export class RunProgramExtra extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RunProgramExtraParser.decode(input).map(res => new RunProgramExtra(res));
    }
    static unsafeDecode(input) {
        return RunProgramExtra.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RunProgramExtraParser.encode(data);
    }
    static schema() {
        return RunProgramExtraParser.schema();
    }
}
